export default {
    crop: {
        title: "Gröda",
        cropSize: "Croppstorlek",
        zoom: "Zooma",
        custom: 'Specialanpassad',
        post: 'Post',
        square: 'Kvadrat',
        landscape: 'Landsskap',
        story: 'Historia',
        portrait: 'Porträtt',
        carousel: 'Karusell',
        commonAspectRatio: 'Vanligt bildförhållande',
    },
};
